import { getPermissionByVersion } from '@Service/versionService';
import Permission from '@Constants/permissions';
import { isAfterOrEqual } from '@Utils/versionUtils';
import store from '@Store';

const hasAnyPermission = (user, allowedPermissions) =>
    allowedPermissions.length && user.permissions
        ? user.permissions.some(
              userPer => allowedPermissions.filter(reqPer => reqPer.value === userPer).length > 0
          )
        : true;

const hasAllPermission = (user, allowedPermissions, currentVersion) => {
    let allFound = true;
    allowedPermissions.forEach(permission => {
        let found = false;
        if (user && user.permissions && user.permissions.length > 0) {
            user.permissions.forEach(usr => {
                if (permission.value === usr) {
                    found = true;
                }
            });
        }

        let permVersion = permission.version;
        if (permVersion.split('.').length === 2) {
            permVersion = `${permVersion}.0`;
        }

        if (
            found === false &&
            (permission.version === 'legacy' || isAfterOrEqual(permVersion, currentVersion))
        ) {
            allFound = false;
        }
    });

    return allFound;
};

const hasAnyLabelAccess = (user, allowedLabels) => {
    if (!user) {
        return false;
    }

    if (
        (user.permissions && user.permissions.some(p => p === Permission.VIEWS_ALL_VIEW.value)) ||
        !allowedLabels
    ) {
        return true;
    }
    const userAccessibleLabels = user.accessibleLabels || [];
    if (allowedLabels.length > 0) {
        return allowedLabels.every(l => userAccessibleLabels.indexOf(l) >= 0);
    }
    return userAccessibleLabels.length > 0;
};

export const isAuthorized = (user, allowedPermissions, allowedLabels) =>
    !!user && hasAnyPermission(user, allowedPermissions) && hasAnyLabelAccess(user, allowedLabels);

export const isAuthorizedAllPermissions = (
    user,
    allowedPermissions,
    allowedLabels,
    currentVersion
) => !!user && hasAllPermission(user, allowedPermissions, currentVersion);

export const canNavTOScoreCard = () => {
    const rootReducer = store.getState();
    const { auth, scoreCard } = rootReducer;
    const { version, user } = auth;

    const { digAppsFilteredArray } = scoreCard;
    const availableDigAppsCount = digAppsFilteredArray.length;
    const scorecardPermissions = getPermissionByVersion('scorecard', version);
    const scorecardAdminPermissions = getPermissionByVersion('scorecard_admin', version);
    const canAnalyzeScorecardPermissions = getPermissionByVersion('canAnalyzeScorecard', version);
    return (
        availableDigAppsCount > 0 &&
        isAuthorizedAllPermissions(user, canAnalyzeScorecardPermissions, ['labelAccess']) &&
        (isAuthorizedAllPermissions(user, scorecardPermissions, ['labelAccess']) ||
            isAuthorizedAllPermissions(user, scorecardAdminPermissions, ['labelAccess'])) &&
        isAfterOrEqual('7.2.1', version)
    );
};

export const canAnalyzeDocument = () => {
    const rootReducer = store.getState();
    const { auth, document } = rootReducer;
    const { version, user } = auth;
    const { userViews } = document;
    const customViewCount = userViews ? userViews.length : 0;
    const canAnalyzePermissions_ViewAll = getPermissionByVersion(
        'canAnalyzeLabels_ViewAll',
        version
    );
    const viewAll = isAuthorizedAllPermissions(user, canAnalyzePermissions_ViewAll, [
        'labelAccess'
    ]);

    const canAnalyzeLabels_CustomViews = getPermissionByVersion(
        'canAnalyzeLabels_CustomViews',
        version
    );

    const customView = isAuthorizedAllPermissions(user, canAnalyzeLabels_CustomViews, [
        'labelAccess'
    ]);

    const viewCustom = customView && customViewCount > 0;
    return viewAll || viewCustom;
};
